import * as React from "react";

enum ApplicationHelpTypeEnum {
	"HTML" = 1,
	"PDFContent" = 2,
}

interface IProps {
    label: string;
    blockKey?: string;
    helpLabel?: string;
    helpType?: ApplicationHelpTypeEnum;
}

const BlockHeading = (label: string, blockKey: string = undefined, helpLabel?: string, helpType?: ApplicationHelpTypeEnum) => {
    return (
        <BlockHeadingComponent label={label} blockKey={blockKey} helpLabel={helpLabel} helpType={helpType}/>
    )
}

export class BlockHeadingComponent extends React.Component<IProps, any> {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { label, blockKey, helpLabel, helpType } = this.props;
        if (label === null || label === undefined)
            return null;

        return (
            <div className={"block-heading"}>
                <h2 style={{ fontWeight: 400 }}>
                    {label}
                </h2>
                {/* {blockKey && <HelpDialog helpKey={blockKey} helpLabel={helpLabel} helpType={helpType}/>} */}
            </div>
        )
    }
}

export default BlockHeading;
